import { createFileRoute } from '@tanstack/react-router';
import { ExchangeLayout } from '../../layouts/Exchange/ExchangeLayout';
import { z } from 'zod';

const exchangeSearchSchema = z.object({
  itemId: z.string(),
  resolutionId: z.string(),
});

export const Route = createFileRoute('/$retailer/exchange')({
  component: ExchangeLayout,
  validateSearch: (search) => {
    const result = exchangeSearchSchema.safeParse(search);
    return result.data;
  },
});
